import type {ExperimentalMode,InteractiveActivityBlock,InteractiveGraphBlock} from './interactive-activity';
import {calibrationRows,calibrationValidation} from './calibration-data';
import {numeric,type XY} from './interactive-graph-model';

// Tables are the existing exchange point for both real measurements and
// measurements received from animations. Keep their pedagogical masking.
export function graphSourcePoints(block:InteractiveGraphBlock,blocks:InteractiveActivityBlock[],answers:Record<string,string>,mode:ExperimentalMode='real'):XY[]{
 const source=blocks.find(b=>b.id===block.sourceTableBlockId);
 if(source?.type!=='measurement_table'||!block.xColumnId||!block.yColumnId)return [];
 if(source.measurementTableKind==='colorimetric'&&block.yColumnId==='colorimetric')return [];
 let rows:Record<string,unknown>[]=[];
 if(source.calibrationSeries){
  const value=answers[source.id]??'';
  const calibration=calibrationRows(source,value,mode,answers[source.concentrationSource?.blockId??'']);
  if(source.validateBeforeGraph&&!calibrationValidation(source,value,calibration).validated)return [];
  rows=calibration;
 }
 else try{
  const parsed=JSON.parse(answers[source.id]||'null');
  rows=Array.isArray(parsed)?parsed:Array.isArray(parsed?.rows)?parsed.rows:source.initialRows??[];
 }catch{rows=source.initialRows??[];}
 return rows.slice(0,200).flatMap(row=>{
  if(!row||typeof row!=='object')return [];
  const measurement=row.source==='simulation'&&row.measurement&&typeof row.measurement==='object'?row.measurement as Record<string,unknown>:{};
  const read=(key:string)=>{
   if(measurement.concentrationHidden&&['concentrationMolL','preparedConcentrationMolL'].includes(key))return null;
   if(key==='distanceCm'&&typeof measurement.distanceM==='number')return measurement.distanceM*100;
   const value=measurement[key]??row[key];return typeof value==='number'&&Number.isFinite(value)?value:typeof value==='string'?numeric(value):null;
  };
  const x=read(block.xColumnId!),y=read(block.yColumnId!);return x===null||y===null?[]:[{x,y}];
 });
}
